import React, { useState } from "react";
import { Link } from "react-router-dom"; // Importamos Link de react-router-dom
import "../styles/HamburgerMenu.css";

const HamburgerMenu = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleLinkClick = () => {
    // Cierra el menú después de hacer clic en un enlace
    setIsOpen(false);
  };

  return (
    <header className="hamburger-menu">
      {/* Logo */}
      <div className="logo">
        <Link to="/">
          <img
            src="https://www.behealthpr.com/wp-content/uploads/2025/02/logo-Behealth-blanco.png"
            alt="Logo de behealth"
          />
        </Link>
      </div>

      {/* Botón hamburguesa */}
      <button
        className={`hamburger-button ${isOpen ? "open" : ""}`}
        onClick={toggleMenu}
        aria-label="Toggle menu"
      >
        <span className="line"></span>
        <span className="line"></span>
        <span className="line"></span>
      </button>

      {/* Menú desplegable */}
      <nav className={`menu-overlay ${isOpen ? "visible" : "hidden"}`}>
        <ul className="menu-items">
          <li>
            <Link to="/" onClick={handleLinkClick}>
              Home
            </Link>
          </li>
          <li>
            <Link to="/adn" onClick={handleLinkClick}>
              ADN
            </Link>
          </li>
          <li>
            <Link to="/audiencias" onClick={handleLinkClick}>
              Audiencias
            </Link>
          </li>
          <li>
            <Link to="/metasistema" onClick={handleLinkClick}>
              MetaSistema
            </Link>
          </li>
          <li>
            <Link to="/solucionespublicitarias" onClick={handleLinkClick}>
              Soluciones Publicitarias
            </Link>
          </li>
          <li>
            <Link to="/ratecard" onClick={handleLinkClick}>
              Rate Card
            </Link>
          </li>
          <li>
            <Link to="/solucionesdecontenido" onClick={handleLinkClick} className="d-none">
              Soluciones de Contenido
            </Link>
          </li>
          <li>
            <Link to="/eventosyexperiencias" onClick={handleLinkClick}  className="d-none">
              Eventos y Experiencias
            </Link>
          </li>
          <li>
            <Link to="/precios" onClick={handleLinkClick}  className="d-none">
              Precios
            </Link>
          </li>
          <li>
            <Link to="/contactanos" onClick={handleLinkClick}  className="d-none">
              Contáctanos
            </Link>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default HamburgerMenu;


